import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LazySelect, { type LazySelectFetchParams } from '@/components/subcomponents/LazySelect.vue'
import * as userClientService from '@/services/userClientService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientSelect',
  props: {
    modelValue: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const languageStore = useLanguageStore()

const selectedId = computed({
  get: () => props.modelValue ?? null,
  set: (value) => emit('update:modelValue', (value as string) ?? null),
})

async function fetchClients({ page, pageSize, search, signal }: LazySelectFetchParams) {
  const res = await userClientService.getMyClients(page, pageSize, search || undefined, signal)
  return res.data
}

async function resolveSelectedClient() {
  const res = await userClientService.getCurrentClient()
  return res.data
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LazySelect, {
    modelValue: selectedId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedId).value = $event)),
    fetcher: fetchClients,
    "resolve-selected": resolveSelectedClient,
    "option-label": "fullName",
    "option-value": "id",
    "filter-fields": ['fullName'],
    placeholder: _unref(languageStore).t('general.selectClient'),
    "empty-message": _unref(languageStore).t('general.noDataFound'),
    "loading-message": _unref(languageStore).t('general.loading'),
    disabled: __props.disabled,
    "page-size": 20,
    class: "w-full text-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change')))
  }, null, 8, ["modelValue", "placeholder", "empty-message", "loading-message", "disabled"]))
}
}

})